import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	createdBy: {
		id: 'search-page.filters.names.createdBy',
		defaultMessage: 'Created by',
		description: 'Label for filtering by creator',
	},
	confluenceFilterCreatorPlaceholder: {
		id: 'search-page.confluence.filter.creator.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for creator filter search input',
	},
	confluenceFilterCreatorLabelSelected: {
		id: 'search-page.confluence.filter.creator.selected',
		defaultMessage: 'Selected',
		description: 'Created by filter selected label',
	},
	confluenceFilterCreatorLabelUnselected: {
		id: 'search-page.confluence.filter.creator.unselected',
		defaultMessage: 'Suggested',
		description: 'Created by filter unselected label',
	},
});
